import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'movie-images-show',
  templateUrl: './movie-images-show.component.html',
  styleUrls: ['./movie-images-show.component.css']
})
export class MovieImagesShowComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    
   
    
  }
  
      
    
  
}
